import { NgClass } from '@angular/common';
import { input, signal, effect, ChangeDetectionStrategy, AfterViewInit, Component, DestroyRef, inject, OnDestroy, OnInit, QueryList, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { Subject, Subscription } from 'rxjs';
import { MDBModalRef } from '../../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../../core/services/auth.service';
import { UserPersistenceService } from '../../../core/services/userPersistence.service';
import { IProjDocUpload } from '../../../shared/interfaces/document.Interface';
import { IVersionNumber } from '../../../shared/interfaces/projects.Interfaces';
import { Constants } from '../../../shared/models/constants';
import { Enums } from '../../../shared/models/enums';
import ProjectDocumentUploadSchema from '../../../shared/schemas/modals/modalProjectDocumentUpload.json';
import { ParentChildCommunicationService } from '../../../shared/services/parent-child-communication.service';
import { CommonDataService } from '../../services/commonData.service';
import { DocumentUploadDataService } from '../../services/documentUploadDataService';
import { DesignDocumentCommentComponent } from '../designLevel/design-document-comment.component/design-document-comment.component';
import { DesignDocumentCommentComponentprelim } from '../designLevel/design-document-commentprelim.component/design-document-commentprelim.component';
import { MeasureDocumentCommentComponent } from '../measureLevel/measure-document-comment.component/measure-document-comment.component';
import { MeasureDocumentCommentComponentprelim } from '../measureLevel/measure-document-commentprelim.component/measure-document-commentprelim.component';
import { ProjectDocumentCommentComponent } from './project-document-comment.component/project-document-comment.component';


@Component({
    selector: '[ifc-project-documentComment-modal]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './project-documentComment-modal.component.html',
    styleUrls: ['./project-documentComment-modal.component.scss'],
    host: { 'class': 'modal-host-right-panel' },
    standalone: true,
    imports: [MatTabGroup, MatTab, MatTabLabel, NgClass, ProjectDocumentCommentComponent, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatButton, DesignDocumentCommentComponent, DesignDocumentCommentComponentprelim, MeasureDocumentCommentComponent, MeasureDocumentCommentComponentprelim]
})
export class ProjectDocumentCommentModalComponent implements OnInit, AfterViewInit, OnDestroy {

    readonly form = input<FormGroup>();
    schema = ProjectDocumentUploadSchema;

    heading: string;
    content: string;
    okButton: string = 'Ok';
    cancelButton: string = 'Cancel';
    projDocUpload: IProjDocUpload;
    projDocUploadPrelim: IProjDocUpload;
    projDocUploadDesign: IProjDocUpload;
    projDocUploadDesignPrelim: IProjDocUpload;
    showEEM27: any;
    selectedVersion: IVersionNumber;
    confirmationStatus = Enums.confirmationStatus;
    action: Subject<any> = new Subject();
    hideOnclose: boolean = false; //to avoid auto call of measureList() and measureListPreliminary() on close
    showComments: boolean = false;
    validationMsg: string = '';
    designValidationMsg: string = '';
    isApprove: boolean = false;
    title: string = '';
    majorVersionV3 = Constants.V3MAJOR_VERSION;
    projectData =
        {
            masterProjectId: '',
            masterProjectName: '',
            projectID: '',
            projectName: '',
            projectStage: '',
            projectSection: '',
            projectStatus: '',
            projectDetailId: '',
            currentCycleNumber: null,
            showProjectDecision: false
        }

    fileAccess = {
        canDeleteDocument: false,
        canUploadDocument: false,
        canDownloadDocument: false,
        canUpdateNarrative: false,
        canViewComment: false,
        canUpdateClientComment: false,
        canUpdateAuditorComment: false,
        canUpdateReviewerComment: false,
        deletableFiles: [],
        canSendForAudit: false,
        disableCAApproveButton: false
    };

    fileAccessMasterLevel = {
        canDeleteDocument: false,
        canUploadDocument: false,
        canDownloadDocument: false,
        canUpdateNarrative: false,
        deletableFiles: []
    };


    selectedmeasure: string;
    selectedmeasurePrelim: string;
    selectedDesignMeasure: string;
    selectedDesignMeasurePrelim: string;
    projectLevelError: Array<any> = [];
    savingsError: Array<any> = [];
    errormsgMeasureLevel: string;
    errormsgDesignLevel: string;
    measureLevelError: Array<any> = [];
    designLevelList: Array<any> = [];
    data: Array<any>;
    prelimData: Array<any>;
    designActiveIndex: number = null;
    sIndex: number = null;

    errormsgMeasureLevelPrelim: string;
    measureLevelErrorPrelim: Array<any> = [];
    errormsgDesignLevelPrelim: string;
    designLevelListPrelim: Array<any> = [];
    dataPrelim: Array<any>;
    pIndex: number = null;
    designActiveprelimIndex: number = null;
    projcnt: any = null;
    prelimprjid: any;
    bshowpriliminary: boolean;
    bdisablepriliminary: boolean = false;
    headingprelim: string = "Measure Level (Preliminary)";
    headingpost: string = "Measure Level (Post-Construction)";
    headingtxt: string = "Measure Level";
    designHeading: string = "Design Level";
    designPostHeading: string = "Design Level (Post-Construction)"
    designPrelimHeading: string ="Design Level (Preliminary)"
    projectLevelAllApproved: boolean = false;
    measureLevelAllApproved: boolean = false;
    designLevelAllApproved: boolean = false;
    showDesignTab: boolean = true;
    showDesignTabPrelim: boolean = true;

    @ViewChildren("measureDocumentCommentComponent")
    public Grids: QueryList<MeasureDocumentCommentComponent>;
    private SearchGrid: MeasureDocumentCommentComponent;

    @ViewChildren("measureDocumentCommentComponentprelim")
    public Gridsprelim: QueryList<MeasureDocumentCommentComponentprelim>;
    private SearchGridprelim: MeasureDocumentCommentComponentprelim;

    @ViewChildren("designDocumentCommentComponent")
    public DesignGrids: QueryList<DesignDocumentCommentComponent>;
    private DesignSearchGrid: DesignDocumentCommentComponent;

    @ViewChildren("designDocumentCommentComponentprelim")
    public DesignGridsprelim: QueryList<DesignDocumentCommentComponentprelim>;
    private DesignSearchGridprelim: DesignDocumentCommentComponentprelim;

    projectStatus = Enums.ProjectStatus;
    projectApprovalStatus = Enums.projectApprovalStatus;
    userRoles = Enums.Role;
    role: string;
    dashboardTranslation: any;
    private readonly destroyRef = inject(DestroyRef);
    showStatusDots: boolean = false;
    showApprovedTicks: boolean = false;
     subscriptionWallValidation: Subscription;
    wallEem08Message: string = '';
    wallEem09Message: string = '';
    wallWarningMessages: string[] = [];
    private readonly wallValidationRequestTrigger = signal(0);

    private readonly wallValidationRequestEffect = effect(() => {
        if (this.wallValidationRequestTrigger() === 0) {
            return;
        }
        this.parentChildCommunicationService.publish('requestWallValidation', {});
    });

    constructor(
        public modalRef: MDBModalRef,
        private documentUploadDataService: DocumentUploadDataService,
        public userPersistenceService: UserPersistenceService,
        private authService: AuthService,
        private parentChildCommunicationService: ParentChildCommunicationService,
        private commonDataService: CommonDataService,
        private cdr: ChangeDetectorRef) {

    }

    ngOnInit() {
        this.hideOnclose = false;
        this.title = this.userPersistenceService.generalTranslation.ReviewDetails;
        if (this.projDocUpload.projectData) {
            this.projectData = Object.assign({}, this.projDocUpload.projectData);
        }
         this.subscriptionWallValidation = this.parentChildCommunicationService.on('wallValidationMessages')
            .subscribe((data: { eem08Message: string, eem09Message: string, typologyMessage: string }) => {
                this.wallEem08Message = data && data.eem08Message ? data.eem08Message : '';
                this.wallEem09Message = data && data.eem09Message ? data.eem09Message : '';
                this.wallWarningMessages = [
                    data && data.typologyMessage ? data.typologyMessage : '',
                    this.wallEem08Message,
                    this.wallEem09Message
                ].filter(m => !!m);
            });

        this.wallValidationRequestTrigger.update((value) => value + 1);
        if (this.projDocUpload.projectAccess) {
            this.fileAccess = Object.assign({}, this.projDocUpload.projectAccess);
            this.fileAccessMasterLevel = Object.assign({}, this.projDocUpload.projectAccess);
        }
        this.role = this.authService.getUserRole();

        this.selectedVersion = this.userPersistenceService.versionDetails;

        this.getProjectMeasureLevelInfo();       

        this.getProjectDetailsByProjectID();
        
        //show approved ticks to relevant role status
        if (this.role === 'Client') {
                this.showApprovedTicks = true;
            }
        else if (this.role === this.userRoles.Administrator || this.role === this.userRoles.CountryAdmin) {
            this.showApprovedTicks = true;
        }
        else if (this.role === 'Auditor') {
            if (this.projDocUpload.projectData.projectStatus === 'Project Under Audit' || this.projDocUpload.projectData.projectStatus === 'Certifier Feedback') {
                this.showApprovedTicks = true;
                this.showStatusDots = true;
            }
        }
        else if (this.role === 'Reviewer') {
            if (this.projDocUpload.projectData.projectStatus === 'Project Under Review') {
                this.showApprovedTicks = true;
                this.showStatusDots = true;
            }
        }
        else if (this.role === 'Certifier Admin') {
            if (this.projDocUpload.projectData.projectStatus === 'Project Under CA Review') {
                this.showApprovedTicks = true;
                this.showStatusDots = true;
            }
        }

        if (this.projDocUpload.projectData.projectStatus === 'Certified' || this.projDocUpload.projectData.projectStatus === 'Certificate Issued') {
            this.showApprovedTicks = true;
            this.showComments = true;
            this.projDocUpload.projectAccess.canViewComment = true;
            this.projDocUploadDesign.projectAccess.canViewComment = true;
        }
    }


    getProjectMeasureLevelInfo() {
        this.documentUploadDataService.getMeasureLevelInfo(this.projectData.projectDetailId, this.userPersistenceService.selectedLanguage)
            .subscribe((response) => {
                this.data = response;
                this.measureLevelError = this.data.filter(e => e.measureId !== '' && e.key === '2' && e.category != 'design');
                this.designLevelList = this.data.filter(e => e.measureId !== '' && e.key === '2' && e.category == 'design');

                if (this.designLevelList.length == 0) {
                    this.showDesignTab = false;
                }

                this.showValidationTicks();

                let projectDocumentsUploaded = this.data.filter(e => e.key === '1');
                this.projectLevelAllApproved = projectDocumentsUploaded.length == 0 ? true : false;
            
                this.cdr.markForCheck();},
                (err: any) => console.error('err at component', err));
    }

    showValidationTicks() {
        let approvedMeasureLevelDocs = this.measureLevelError.filter(x => x.approved == false);
        this.measureLevelAllApproved = approvedMeasureLevelDocs.length == 0 ? true : false;

        let approvedDesignLevelDocs = this.designLevelList.filter(x => x.approved == false);
        this.designLevelAllApproved = approvedDesignLevelDocs.length == 0 ? true : false;
    }

    onOkClick() {
        this.modalRef.hide();
        this.action.next('ok');
    }

    onCancelClick() {
        this.modalRef.hide();
        this.hideOnclose = true;
        this.action.next('Cancel');
    }

    updateProjectHeaderTicker(isShow: boolean) {
        this.projectLevelAllApproved = isShow;
    }

    public ngAfterViewInit(): void {
        this.Grids.changes.subscribe((comps: QueryList<MeasureDocumentCommentComponent>) => {
            this.SearchGrid = comps.first;
        
            this.cdr.markForCheck();});

        this.Gridsprelim.changes.subscribe((compsprelim: QueryList<MeasureDocumentCommentComponentprelim>) => {
            this.SearchGridprelim = compsprelim.first;
        
            this.cdr.markForCheck();});

        this.DesignGrids.changes.subscribe((designComps: QueryList<DesignDocumentCommentComponent>) => {
            this.DesignSearchGrid = designComps.first;
        
            this.cdr.markForCheck();});

        this.DesignGridsprelim.changes.subscribe((designCompsprelim: QueryList<DesignDocumentCommentComponentprelim>) => {
            this.DesignSearchGridprelim = designCompsprelim.first;
        
            this.cdr.markForCheck();});

    }

    showMeasureLevelDocUpload(measure, index, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.projDocUpload.projectData.measure = measure;
        this.selectedmeasure = measure;
        this.sIndex = index;
        if (this.SearchGrid) {
            this.SearchGrid.loadCommentEditor = false;
            this.SearchGrid.ReloadData(this.projDocUpload);
        } else {
            setTimeout(() => this.userPersistenceService.ReloadMeasureUploadChangedEmit(this.projDocUpload));
        }
        this.cdr.markForCheck();
    }

    showDesignLevelDocUpload(measure, index, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.projDocUploadDesign.projectData.measure = measure;
        this.selectedDesignMeasure = measure;
        this.designActiveIndex = index;
        if (this.DesignSearchGrid) {
            this.DesignSearchGrid.loadCommentEditor = false;
            this.DesignSearchGrid.ReloadData(this.projDocUploadDesign);
        } else {
            setTimeout(() => this.userPersistenceService.ReloadDesignUploadChangedEmit(this.projDocUploadDesign));
        }
        this.cdr.markForCheck();
    }

    measureLevelFileUploadSuccess(isValid: boolean) {
        this.measureLevelError.find(x => x.measureId == this.projDocUpload.projectData.measure).approved = isValid;
        this.parentChildCommunicationService.on('onEnableEditMeasureStatus').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (data) => {
                this.measureLevelError.find(x => x.measureId == this.projDocUpload.projectData.measure).status = data.measure
            
                this.cdr.markForCheck();});
        this.showValidationTicks();
    }

    measureLevelFileUploadPrelimSuccess(imeasureListPreliminarysValid: boolean) {
        this.measureLevelErrorPrelim.find(x => x.measureId == this.projDocUploadPrelim.projectData.measure).approved = imeasureListPreliminarysValid;
        this.parentChildCommunicationService.on('onEnableEditMeasureStatus').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (data) => {
                this.measureLevelErrorPrelim.find(x => x.measureId == this.projDocUploadPrelim.projectData.measure).status = data.measure
            
                this.cdr.markForCheck();});
    }

    designLevelFileUploadSuccess(isValid: boolean) {
        this.designLevelList.find(x => x.measureId == this.projDocUploadDesign.projectData.measure).approved = isValid;
        this.parentChildCommunicationService.on('onEnableEditMeasureStatus').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (data) => {
                this.designLevelList.find(x => x.measureId == this.projDocUploadDesign.projectData.measure).status = data.measure
            
                this.cdr.markForCheck();});
        this.showValidationTicks();
    }

    designLevelFileUploadPrelimSuccess(isValid: boolean) {
        this.designLevelListPrelim.find(x => x.measureId == this.projDocUploadDesignPrelim.projectData.measure).approved = isValid;
        this.parentChildCommunicationService.on('onEnableEditMeasureStatus').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            (data) => {
                this.designLevelListPrelim.find(x => x.measureId == this.projDocUploadDesignPrelim.projectData.measure).status = data.measure
            
                this.cdr.markForCheck();});
    }

    measureList(tab: string): any {
        if (tab == 'measure') {
            if (this.measureLevelError.length > 0) {
                this.selectedmeasure = this.measureLevelError[0].measureId;
                this.projDocUpload.projectData.measure = this.selectedmeasure;
                this.sIndex = 0;
                // Only emit reload event if component already exists in DOM.
                // On first render, the component self-initializes via ngOnInit → initData().
                if (this.SearchGrid) {
                    setTimeout(() => {
                        this.userPersistenceService.ReloadMeasureUploadChangedEmit(this.projDocUpload);
                    });
                }
            }
        }

        if (tab == 'design') {
            if (this.designLevelList.length > 0) {
                this.selectedDesignMeasure = this.designLevelList[0].measureId;
                this.projDocUploadDesign.projectData.measure = this.selectedDesignMeasure;
                this.designActiveIndex = 0;
                // Only emit reload event if component already exists in DOM.
                if (this.DesignSearchGrid) {
                    setTimeout(() => {
                        this.userPersistenceService.ReloadDesignUploadChangedEmit(this.projDocUploadDesign);
                    });
                }
            }
        }
    }

    getProjectDetailsByProjectID() {
        this.documentUploadDataService.getProjectDetailsByProjectID(this.projectData.projectID)
            .subscribe((response) => {
                this.projcnt = response.length;
                this.prelimData = response;
                this.prelimData = this.prelimData.filter(x => x.projectStage.name == 'Preliminary');
                this.prelimprjid = this.prelimData[0].id;
                this.showDesignTabPrelim = this.prelimData[0].showDesignTab;
                this.showEEM27 = JSON.parse(response[0].jsonData);
                if (this.projcnt > 1) {
                    this.bshowpriliminary = true;
                    this.headingtxt = this.headingpost;
                    this.designHeading = this.designPostHeading;
                    this.showComments = true;
                }
                else
                    this.bshowpriliminary = false;
            
                this.cdr.markForCheck();},
                (err: any) => console.error('err at component', err));

    }

    getPreliminaryData(tab:string): any {
        if (this.commonDataService.isUndefinedOrNull(this.dataPrelim)) {
            this.documentUploadDataService.getMeasureLevelInfo(this.prelimprjid, this.userPersistenceService.selectedLanguage)
                .subscribe((response) => {
                    this.dataPrelim = response;
                    this.measureLevelErrorPrelim = this.dataPrelim.filter(e => e.measureId !== '' && e.key === '2' && e.projectStage == 'Preliminary' && e.category != 'design');
                    this.designLevelListPrelim = this.dataPrelim.filter(e => e.measureId !== '' && e.key === '2' && e.projectStage == 'Preliminary' && e.category == 'design');

                    this.loadTabDataPrelim(tab);

                
                    this.cdr.markForCheck();},
                    (err: any) => console.error('err at component', err));
        }
        else {
            this.loadTabDataPrelim(tab);
        }
    }

    loadTabDataPrelim(tab: string) {
        if (tab == 'Measure') {
            if (this.measureLevelErrorPrelim.length > 0) {
                this.projDocUploadPrelim = JSON.parse(JSON.stringify(this.projDocUpload));
                this.projDocUploadPrelim.projectData.projectDetailId = this.prelimprjid;
                this.projDocUploadPrelim.projectData.projectStage = "Preliminary";
                this.projDocUploadPrelim.projectData.currentCycleNumber = "";
                this.selectedmeasurePrelim = this.measureLevelErrorPrelim[0].measureId;
                this.projDocUploadPrelim.projectData.measure = this.selectedmeasurePrelim;
                this.userPersistenceService.ReloadMeasureUploadChangedPrelimEmit(this.projDocUploadPrelim);
                this.pIndex = 0;
            }
        }
        if (tab == 'Design') {
            if (this.designLevelListPrelim.length > 0) {
                this.projDocUploadDesignPrelim = JSON.parse(JSON.stringify(this.projDocUploadDesign));
                this.projDocUploadDesignPrelim.projectData.projectDetailId = this.prelimprjid;
                this.projDocUploadDesignPrelim.projectData.projectStage = "Preliminary";
                this.projDocUploadDesignPrelim.projectData.currentCycleNumber = "";
                this.selectedDesignMeasurePrelim = this.designLevelListPrelim[0].measureId;
                this.projDocUploadDesignPrelim.projectData.measure = this.selectedDesignMeasurePrelim;
                this.userPersistenceService.ReloadDesignUploadChangedPrelimEmit(this.projDocUploadDesignPrelim)
                this.designActiveprelimIndex = 0;
            }
            else {
                this.showDesignTabPrelim = false;
            }
        }
    }
    
    showMeasureLevelPelimDocUpload(measure, index, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.projDocUploadPrelim.projectData.measure = measure;
        this.selectedmeasurePrelim = measure;
        this.pIndex = index;
        if (this.SearchGridprelim) {
            this.SearchGridprelim.loadCommentEditor = false;
            this.SearchGridprelim.ReloadData(this.projDocUploadPrelim);
        } else {
            setTimeout(() => this.userPersistenceService.ReloadMeasureUploadChangedPrelimEmit(this.projDocUploadPrelim));
        }
        this.cdr.markForCheck();
    }

    showDesignLevelPelimDocUpload(measure, index, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.projDocUploadDesignPrelim.projectData.measure = measure;
        this.selectedDesignMeasurePrelim = measure;
        this.designActiveprelimIndex = index;
        if (this.DesignSearchGridprelim) {
            this.DesignSearchGridprelim.loadCommentEditor = false;
            this.DesignSearchGridprelim.ReloadData(this.projDocUploadDesignPrelim);
        } else {
            setTimeout(() => this.userPersistenceService.ReloadDesignUploadChangedPrelimEmit(this.projDocUploadDesignPrelim));
        }
        this.cdr.markForCheck();
    }

    onTabChange(event: any) {
        const label = event.tab?.textLabel;
        if (label === 'measurepost') {
            this.measureList('measure');
        } else if (label === 'measureprelim') {
            this.getPreliminaryData('Measure');
        } else if (label === 'designpost') {
            this.measureList('design');
        } else if (label === 'designprelim') {
            this.getPreliminaryData('Design');
        }
    }

    approveThroughReferenceClick() {
        this.parentChildCommunicationService
            .publish('projectDecision',
                {
                    decision: 'approveThroughRef', role: this.role, projectData: this.projDocUpload.projectData
                });
    };

    approveOrRejectProject(approvalStatus: Enums.projectApprovalStatus) {
        let invalidMeasure = this.measureLevelError.length > 0 ? this.measureLevelError.filter(x => x.approved == false).map(x => x.measureId) : [];
        let invalidDesignMeasure = this.designLevelList.length > 0 ? this.designLevelList.filter(x => x.approved == false).map(x => x.value) : [];

        if (approvalStatus == Enums.projectApprovalStatus.approved) {
            this.validationMsg = invalidMeasure.length > 0 ? 'Please \'Approve\' the following measure(s): ' + invalidMeasure.join(', ') : '';
            this.designValidationMsg = invalidDesignMeasure.length > 0 ? 'Please \'Approve\' the following measure(s): ' + invalidDesignMeasure.join(', ') : '';
            this.isApprove = true;
        }
        else if (approvalStatus == Enums.projectApprovalStatus.rejected || approvalStatus == Enums.projectApprovalStatus.rejectedAndSendToCA) {
            this.validationMsg = invalidMeasure.length == 0 ? 'You should reject at least one measure before rejecting Subproject.' : '';
            this.designValidationMsg = invalidDesignMeasure.length == 0 ? 'You should reject at least one measure before rejecting Subproject.' : '';
            this.isApprove = false;
        }
        if (this.validationMsg == '' || this.designValidationMsg == '') {
            this.parentChildCommunicationService
                .publish('projectDecision',
                    {
                        decision: 'approveOrRejectProject', approvalStatus: approvalStatus, role: this.role, projectData: this.projDocUpload.projectData
                    });
        }
        else
            this.title = this.userPersistenceService.generalTranslation.MissingCondition;

    }

    sendForAudit() {
        this.parentChildCommunicationService
            .publish('projectDecision',
                {
                    decision: 'sendForAudit', role: this.authService.getUserRole(), projectData: this.projDocUpload.projectData, showEEM27: this.showEEM27
                });
    }

    ngOnDestroy() {
        if (this.subscriptionWallValidation) {
            this.subscriptionWallValidation.unsubscribe();
        }
    }

}
